import { Col, Form, Row, Select } from "antd";
import RegimeTributario from "../../../../../Models/Financeiro/Faturamento/Imposto/RegimeTributario";
import Origem from "../../../../../Models/Financeiro/Titulo/Origem";
import OrigemTipoSelect from "./OrigemTipo/OrigemTipoSelect";
import { EnumOrigemTipo } from "../../../../../Models/Financeiro/Titulo/Origem/OrigemTipo";
import ViagemSelect from "../../../Viagem/ViagemSelect";
import { NamePath } from "antd/lib/form/interface";
import { Rule } from "antd/es/form";
import { RestFilled } from "@ant-design/icons";
import InscricaoResponsavelSelect from "@/Components/Populados/Viagem/Inscricao/InscricaoResponsavelSelect";
import { EnumStatusDaViagem } from "@/Models/Domain/Viagem/StatusDaViagem";
type InputProps = "codTipo" | "codReferencia";
interface IOrigemSelectProps<T> extends Omit<React.ComponentProps<typeof Select>, "value" | "onChange" | "showSearch" | "optionFilterProp" | "filterOption"> {
    onChange?:(value:Origem|null) => void;
    value?:Origem|null;
    initValue?:Origem|null;
    names: { [ key in InputProps ] : NamePath<T> }
    rules?: { [ key in InputProps ] : Rule[] }
    defa
    inscricaoProps : {
        codResponsavel?:number
    },
    isAlteracao?:boolean
}
export default function OrigemSelect<Origem> ({
    onChange,
    value,
    initValue,
    names,
    rules,
    inscricaoProps,
    isAlteracao,
    ...props
}:IOrigemSelectProps<Origem>) {
    isAlteracao = isAlteracao ?? false;
    const form = Form.useFormInstance<Origem>();
    const codTipoState = Form.useWatch(names["codTipo"], form);
    const initCodViagemValue = initValue?.codTipo == EnumOrigemTipo.Viagem ? initValue?.codReferencia : null;

    return <Row style={{width : "100%"}} gutter={8} wrap>
        <Col xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}>
            <Form.Item<Origem> 
                label={"Tipo origem"} 
                name={names["codTipo"]}
                rules={rules == undefined ? undefined : rules["codTipo"]}
            >
                <OrigemTipoSelect 
                    disabled={props.disabled}
                    onChange={() => {
                        form.setFieldValue(names["codReferencia"], undefined);
                    }}
                />
            </Form.Item>
        </Col>
        <Col xs={16} sm={16} md={16} lg={16} xl={16} xxl={16}>
            {
                codTipoState === EnumOrigemTipo.Viagem && <Form.Item<Origem>
                    label="Viagem"
                    name={names["codReferencia"]}
                    rules={rules == undefined ? undefined : rules["codReferencia"]}
                >
                    <ViagemSelect 
                        disabled={props.disabled}
                        codSituacoesInvalidas={[EnumStatusDaViagem.CANCELADA, EnumStatusDaViagem.ENCERRADA]}
                        codViagemIgnorarFiltro={initCodViagemValue ?? undefined}
                    />
                </Form.Item>
            }
            {
                codTipoState === EnumOrigemTipo.Inscricao && <Form.Item<Origem>
                    label="Inscrição"
                    name={names["codReferencia"]}
                    rules={rules == undefined ? undefined : rules["codReferencia"]}
                >
                    <InscricaoResponsavelSelect 
                        disabled={props.disabled}
                        codResponsavel={inscricaoProps.codResponsavel}
                    />
                </Form.Item>
            }
        </Col>
    </Row>;
}
